var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{ref:"simplebarElement",class:_vm.className},[_c('DynamicElement',{class:_vm.contentClass,attrs:{"tag":_vm.contentTag}},[_vm._t("default")],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }